import React from 'react';
import PropTypes from 'prop-types';
import GenericError from './GenericError';
import NavigationHistory from '../../libs/NavigationHistory';

/**
 * Show the server state errors on the filter editor.
 */

const FilterEditorError = (props) => {
  const { errorCode, navigationHistory } = props;
  return (
    <GenericError
      navigationHistory={navigationHistory}
      errorCode={errorCode}
      message401={i18n('You are not allowed to save these filter options.')}
      message403={i18n('You are not allowed to save these filter options.')}
      message404={i18n('The filter options could not be found.')}
    />
  );
};

FilterEditorError.propTypes = {
  errorCode: PropTypes.oneOf(['', 400, 401, 403, 404, 429, 501, 502]),
  navigationHistory: PropTypes.instanceOf(NavigationHistory).isRequired
};

export default FilterEditorError;
